import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS types
import { ITHSRInfoData, NotIncludeObj, IPlanList_Format, IPlanDetail } from '@redux/common';
// Redux
import { RootState } from '@redux/store';

// import module

// shared component
import MiniCalendar from '@component/Common/MiniCalendar';

// common function
import { convertTicketNum, getCommonAbleDates, generateDates } from '@libs/core';
import { setGDSSessionData } from '@libs/apiCall'; //TODO: Session API 待處理

// plugin
import dayjs from 'dayjs';

// redux actions
import { 
    setTCalendarErrorMsg, 
    setTPickCalendar, 
    setTSessionErrorMsg, 
    setTSubmitErrMsg, 
    setTTempCalendarData,
    setTAllSessions,
    setTPickSession,
    setTTicketErrorMsg,
    setTTicketNum,
    setTFinalAbleDates
} from '@redux/NormalT/actions';

interface ICalendarProps {
    // TODO: 有時間再定義
}

interface loopDates {
    (start: string, end: string): string[];
}

const TCalendarBlock: React.FC<ICalendarProps> = (props) => {
    // console.log('CalendarBlock', props);
    const dispatch = useDispatch();
    const {
        DetailData,
        TempCalendarData,
        pickCalendar,
        ticketNum,
        calendarErrorMsg,
        sessionErrorMsg,
        ticketErrorMsg,
        NowListData,
        isSessionLoading,
        allSessions,
        pickSession,
        soldoutDate,
        disabledDateBySession,
        nullDate,
        disabledDate,
        SubmitErrMsg,
    } = useSelector((state: RootState) => state.NormalT);
    const { ETID, ListData, DetailFetchAllData } = useSelector((state: RootState) => state.Common);
    const { FormatID }: IPlanList_Format = NowListData;
    const { LastBuyDay }: IPlanDetail = DetailData;

    const { THSRInfo } = useSelector((state: RootState) => state.THSR);
    const { ProductUseDate }: ITHSRInfoData = THSRInfo;

    // 如果沒有可賣日期將今天min && max設為當日再用disabled date扣掉今天
    // const min: string = DetailFetchAllData[0]?.EarliestBuyDay || dayjs().format('YYYY-MM-DD');
    let min = ((DetailEBDay: string) => {
        if(!DetailEBDay) return dayjs().format('YYYY-MM-DD');
        if(!DetailFetchAllData) return DetailEBDay;

        const storedDetailAllData = ListData.ItemType === "0"
            ? DetailFetchAllData //自建高鐵只有一個方案
            : DetailFetchAllData.filter(item => item.listID === FormatID ) //GDS高鐵會有多方案

        if(!storedDetailAllData[0].listDetail.EarliestBuyDay){ //detail最早日會變動，所以要拿stored的detail最早日  TODO: detail最早日已改成固定
            return DetailEBDay //第一次打 DetailFetchAllData還未儲存
        }else{
            return storedDetailAllData[0].listDetail.EarliestBuyDay
        }
    })(DetailData?.EarliestBuyDay)
    console.log("min~~~~~~~",min)
    const max: string = LastBuyDay || dayjs().format('YYYY-MM-DD'); 
    const noAvailableDays = !min && !LastBuyDay;
    const notIncludes = DetailData?.NotIncludeDate;

    /* -------月曆初始化邏輯START----------*/
    // 客製不可選日子陣列
    const disabledDates = ((dates: NotIncludeObj[], callback: loopDates) => {
        if (noAvailableDays) return [dayjs().format('YYYY-MM-DD')]; // 如果沒有可賣日期將今天設為disabled

        const allDisabled = [];

        // 備用 自己將0元也設進disabled
        // if (GDetail.CalendarDate) {
        //     const includeDate = Object.keys(GDetail.CalendarDate);
        //     if (includeDate.length !== 0) {
        //         includeDate?.map((item) => {
        //             if (GDetail.CalendarDate[item].LowestPrice === 0) {
        //                 allDisabled.push(item);
        //             }
        //         });
        //     }
        // }

        dates?.forEach((item: NotIncludeObj) => {
            if (item) {
                allDisabled.push(...callback(item.StartDate, item.EndDate));
            }
        });
        return allDisabled;
    })(notIncludes, generateDates);

    // 可選日子陣列
    const ableDates = ((oriDates: string[], disableDates: string[]) => {

        const sortDate = oriDates.filter(function (dates) {
            return this.indexOf(dates) < 0;
        }, disableDates);

        return sortDate;
    })(generateDates(min, max), disabledDates);

    /* -------月曆初始化邏輯END----------*/

    // 高鐵限制使用日期與票券本身可使用日期比對重疊之日期作為最終可使用日期
    // const ableDatesByTHSRLimit = useMemo(() => {
    //     if (!nullDate || nullDate.length === 0) {
    //         return getCommonAbleDates([availableDate, ProductUseDate]);
    //     }
    //     const filterNullDate = availableDate.filter(function (item) {
    //         return this?.indexOf(item) === -1;
    //     }, nullDate);
    //     return getCommonAbleDates([filterNullDate, ProductUseDate]);
    // }, [availableDate, nullDate]);

    // 高鐵限制使用日期與票券本身可使用日期比對重疊之日期作為最終可使用日期
    // 切換品項時，要重新render最終可使用日期
    const ableDatesByTHSRLimit = useMemo(() => getCommonAbleDates([ableDates, ProductUseDate]), [FormatID]);

    // 設定最終篩選過後的可選日期並預選第一個日子，並重打一次session
    useEffect(() => {
        let newDate; // 最終篩選過後的第一個日子的session
        // console.log("ableDatesByTHSRLimit🤷‍♀️🤷‍♀️", ableDatesByTHSRLimit);
        if (NowListData?.ExpectedUseDay) {
            dispatch(setTFinalAbleDates(ableDatesByTHSRLimit));
            if (ableDatesByTHSRLimit[0] == null) {
                dispatch(setTPickCalendar(null));
                newDate = null;
                return;
            }
            if (ableDatesByTHSRLimit[0] !== pickCalendar) {
                dispatch(setTPickCalendar(ableDatesByTHSRLimit[0]));
            }
            newDate = ableDatesByTHSRLimit[0];
        } else {
            dispatch(setTFinalAbleDates(ProductUseDate));
            if (ProductUseDate[0] == null) {
                dispatch(setTPickCalendar(null));
                newDate = null;
                return;
            }
            if (ProductUseDate[0] !== pickCalendar) {
                dispatch(setTPickCalendar(ProductUseDate[0]));
            }
            newDate = ProductUseDate[0];
        }

        /* TODO: 第三階段調整
        DetailData.Sessions &&
        setGDSSessionData({
            date: newDate,
            FormatID,
            ETID,
            context: {
                setGSessionLoading: setIsTGDSSessionLoading,
                setGSessionFetchFail: setTGDSSessionFetchFail,
                setSession,
                setSessionPicked,
            },
            dispatch,
        });
        */

    }, [ableDatesByTHSRLimit, NowListData]);

    //點選月曆
    const onClickDate = (date: string) => {
        const tickets = convertTicketNum(
            NowListData.ExpectedUseDay
                ? DetailData.CalendarDate[date]?.ETItem
                : DetailData.ETItem
        );
        if(NowListData.ExpectedUseDay) dispatch(setTTempCalendarData(DetailData.CalendarDate));
        
        dispatch(setTTicketNum(tickets));
        dispatch(setTPickCalendar(date));
        // TODO: 第一、二階段暫時先用
        if(DetailData.Sessions) {
            dispatch(setTAllSessions(DetailData.CalendarDate[date].Events));
            dispatch(setTPickSession(DetailData.CalendarDate[date].Events[0])) //預設選定第一筆session
        }
        /* TODO: 第三階段調整
        DetailData.Sessions &&
            setGDSSessionData({
                date,
                FormatID,
                ETID,
                context: {
                    setGSessionLoading: setIsTGDSSessionLoading,
                    setGSessionFetchFail: setTGDSSessionFetchFail,
                    setSession,
                    setSessionPicked,
                },
                dispatch,
            });
        */
        sessionErrorMsg && dispatch(setTSessionErrorMsg(''));
        calendarErrorMsg && dispatch(setTCalendarErrorMsg(''));
        ticketErrorMsg && dispatch(setTTicketErrorMsg(''));
        SubmitErrMsg && dispatch(setTSubmitErrMsg(''));
    };

    const isMinAfterMax = dayjs(min).isAfter(max);
    // 如果最早日比最晚日還晚(因工作日規則會往後順延startDate卻不會順延EndDate)，將此特殊情況設日曆為null
    isMinAfterMax && dispatch(setTPickCalendar(null));

    return (
        <MiniCalendar
            dates={NowListData?.ExpectedUseDay ? ableDatesByTHSRLimit : ProductUseDate}
            onClickDate={(date: string) => {
                onClickDate(date);
            }}
            defaultdate={pickCalendar}
            forceSelect={true}
        />
    );
};

export default TCalendarBlock;